import { DefaultLoadingManager } from 'three';
import create from 'zustand';

// type Data = {
//   errors: string[]
//   active: boolean
//   progress: number
//   item: string
//   loaded: number
//   total: number
// }
let saveLastTotalLoaded = 0;

/**
 * Fork of drei useProgress
 *  - wrap set() in setTimeout() to avoid React warning
 *    (Warning: Cannot update a component (`Loader`) while rendering a different component (`Model`).)
 */

const useProgress = /* @__PURE__ */ create(set => {
  DefaultLoadingManager.onStart = (item, loaded, total) => {
    setTimeout(() =>
      set({
        active: true,
        item,
        loaded,
        total,
        progress: ((loaded - saveLastTotalLoaded) / (total - saveLastTotalLoaded)) * 100,
      }),
    );
  };
  DefaultLoadingManager.onLoad = () => {
    setTimeout(() => set({ active: false }));
  };
  DefaultLoadingManager.onError = item =>
    setTimeout(() => set(state => ({ errors: [...state.errors, item] })));
  DefaultLoadingManager.onProgress = (item, loaded, total) => {
    if (loaded === total) {
      saveLastTotalLoaded = total;
    }
    setTimeout(() =>
      set({
        active: true,
        item,
        loaded,
        total,
        progress: ((loaded - saveLastTotalLoaded) / (total - saveLastTotalLoaded)) * 100 || 100,
      }),
    );
  };
  return {
    errors: [],
    active: false,
    progress: 0,
    item: '',
    loaded: 0,
    total: 0,
  };
});

export { useProgress };
